import { Box, Title, Link } from "./Footer.styled";

export const Catalog = () => {
    return (
        <Box>
            <Title>Каталог</Title>
            <Link to='/batteries'>Елементи</Link>
            <Link to='/assembly'>Готові комплекти</Link>
            <Link to='/batteries-for-fpv'>FPV-дрони</Link>
            <Link to='/batteries-for-transport'>Електротранспорт</Link>
            <Link to='/batteries-for-toys'>Іграшки</Link>
            <Link to='/devices'>Прилади</Link>
            <Link to='/materials'>Витратні матеріали</Link>
            <Link to='/3D-print'>3D Друк</Link>
        </Box>
    );
};